"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChoicesWithParams = void 0;
const getChoicesWithParams = (labels, fieldFrom) => {
    var _a, _b;
    if (!((_a = fieldFrom.params) === null || _a === void 0 ? void 0 : _a.choices)) {
        return labels.map((label) => ({ label }));
    }
    const choicesFromDict = (_b = fieldFrom.params) === null || _b === void 0 ? void 0 : _b.choices.reduce((acc, { label, weight, value_help_text }) => ({
        ...acc,
        [label]: { weight, value_help_text },
    }), {});
    return labels.map((label) => {
        var _a, _b;
        const weight = (_a = choicesFromDict[label]) === null || _a === void 0 ? void 0 : _a.weight;
        const value_help_text = (_b = choicesFromDict[label]) === null || _b === void 0 ? void 0 : _b.value_help_text;
        return {
            label,
            ...(weight ? { weight } : {}),
            ...(value_help_text ? { value_help_text } : {}),
        };
    });
};
exports.getChoicesWithParams = getChoicesWithParams;
